export const environment = {
  production: false,
  baseUrl: 'https://test.reveon.nl/',
  registrationThankYouPage: 'https://test.reveon.nl/app/#/login',
  apiPrefix: 'api/',
  profile: 'TEST',
  stripe: {
    key: 'pk_test_jiOlX0L0ERRVXnAUQ74klFlT00l3euj0Hz',
    redirectUrl: 'https://test.reveon.nl/api/payment/redirect'
  }
};
